import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import DryBeansProduct from 'models/DryBeansProduct'
import DryBeansPackage from './DryBeansPackage'

const productOptions = {
  packagingInfo: <DryBeansPackage />,
  productTitle: 'Dry Beans/Peas/Lentils',
  model: DryBeansProduct,
  validCategories: ['06'],
  validSubCategories: ['002'],
}

const DryBeans = () => <ProductForm product={productOptions} />

export default DryBeans

export const getDryBeansPackage = newProduct => {
  const newPeanutButterPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Dry Beans, Peas, Lentils',
    SaltContent: 'null',
    BeanPeaLentilSize: newProduct.BeanPeaLentilSize,
    Organic: newProduct.Organic,
    PBType: 'null',
    PBTexture: 'null',
    PBContainerSize: 'null',
  }
  return newPeanutButterPackage
}
export const updateDryBeansPackage = newProduct => {
  const newPeanutButterPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Dry Beans, Peas, Lentils',
    SaltContent: 'null',
    Organic: newProduct.Organic,
    PBType: 'null',
    PBTexture: 'null',
    PBContainerSize: 'null',
    BeanPeaLentilSize: newProduct.BeanPeaLentilSize,
  }
  return newPeanutButterPackage
}
